import { useQuery } from '@tanstack/react-query'
import { getProcurementPurchaseRequest } from 'api'
import { useParams } from 'react-router-dom'
import { CreateProcurement } from './CreateProcurement'

const EditProcurementDraft = () => {
  const { id } = useParams()
  const { data, isLoading } = useQuery({
    queryKey: ['procurement-details', id],
    queryFn: () => getProcurementPurchaseRequest(id),
  })
  if (isLoading) return <div>Loading...</div>
  if (!data) return <div>No data</div>
  return <CreateProcurement defaultValues={data} />
}

export default EditProcurementDraft
